
import { usePathAndData } from "../../../hook/usePathAndData";
import { AppLayout } from "../../layout/AppLayout";
import { ListaArticulos } from "../../view/Articulos/ListaArticulos";


export const PageArticulos = () => {
    const { path, dataValue } = usePathAndData(); // Usa el hook

    return (
        <AppLayout>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="card">
                            <div className="card-body" style={{ borderRadius: "13px" }}>
                                {path[1] === "articulos" && path[2] === "lista" && <ListaArticulos />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    );
};
